<template>
  <div class="p-10">
    <div class="mb-5">ADD USERS</div>
   <!-- <pre>
    {{ roles}}
   </pre> -->
    <div>
      <div class="flex">
        <v-text-field
          placeholder="First Name"
          v-model="firstName"
        ></v-text-field>
        <v-text-field
          class="ml-10"
          placeholder="Last Name"
          v-model="lastName"
          color
        ></v-text-field>
      </div>
      <div class="flex">
        <v-text-field
          class="mr-10"
          placeholder="Email"
          v-model="email"
        ></v-text-field>
        <v-text-field
          type="password"
          placeholder="Password"
          v-model="password"
        ></v-text-field>
      </div>
      <div class="flex">
        <v-autocomplete
          label="Role"
          :items="roles"
          item-value="role_id"
          item-text="role"
          v-model="role"
          autocomplete
        ></v-autocomplete>
        <v-autocomplete
          class="ml-10"
          label="Department"
          :items="departments"
          item-text="department"
          item-value="department_id"
          v-model="department"
          autocomplete
        ></v-autocomplete>
      </div>
    </div>
    <div class="mt-5">
      <v-btn
        @click="$emit('cancelAddDialog')"
        small
        elevation=""
        color=""
        class="mr-2"
        >CANCEL</v-btn
      >
      <v-btn small @click="submit">SUBMIT</v-btn>
    </div>
    <v-snackbar top v-model="snackbar">
      {{ snackbarMessage }}
      <v-btn test color="primary" @click.native="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import Axios from "axios";
import EventBus from "@/EventBus";
export default {
  data() {
    return {
      email: "",
      password: null,
      snackbarMessage: null,
      snackbar: false,
      departments: [],
      department: null,
      role: "",
      firstName: null,
      lastName: null,
      roles: [],
    };
  },
  mounted() {
    this.getRoles();
    this.getDepartments();
  },
  
  methods: {
    submit() {
      if (
        !this.email ||
        !this.department ||
        !this.role ||
        !this.firstName ||
        !this.lastName
      ) {
        alert("Please complete all fields");
      } else {
        let data = {
          firstName: this.firstName,
          email: this.email,
          lastName: this.lastName,
          role: this.role,
          department: this.department,
          password: this.password,
        };
        Axios.post("/users", data).then((res) => {
          if (!res.data.status) {
            this.snackbarMessage = res.data.message;
            this.snackbar = true;
          }else{
            EventBus.$emit("refreshUsers", 'added')
          }
        });
      }
    },
    getRoles() {
      Axios.get("/roles").then((res) => {
        this.roles = res.data;
      });
    },
    getDepartments() {
      Axios.get("/departments").then((res) => {
        this.departments = res.data;
      });
    },
  },
};
</script>